import React from 'react'

export default function TrainingConfirmation() {
    return <div>Training Confirmation</div>
}
